import React from 'react';

import Feature from '../feature/Feature';
import styles from './Advantages.m.sass';

import safeIcon from './assets/save.svg';
import qualityIcon from './assets/quality.svg';
import deliveryIcon from './assets/delivery.svg';
import withMediaQueries from '../../containers/withMediaQueries/withMediaQueries';
import OnlineSupport from '../onlineSupport/OnlineSupport';

@withMediaQueries({ collapsed: '(max-width: 991px)' }, { collapsed: false })
export default class Advantages extends React.PureComponent {
  render() {
    const { collapsed } = this.props;

    return (
      <section className={styles.advantages}>
        <div className="container">
          <div className={styles.items}>
            <Feature
              icon={safeIcon}
              header="Safe Carries"
              desc="Only reliable and professional carries. No reselling to the other stores or suspicious boosters. We do not use cheats or 3rd party applications."
            />
            <Feature
              icon={qualityIcon}
              header="Best Service"
              desc="Highly experienced boosters. We provide the best result with a personal approach to every client. Our players are raiding in Top 20 guilds in world."
            />
            <Feature
              icon={deliveryIcon}
              header="Fast and Proficient"
              desc="We provide our service in a timely manner. Make your order and get contacted within moments."
            />
          </div>

          {collapsed && <OnlineSupport />}
        </div>
      </section>
    );
  }
}




// WEBPACK FOOTER //
// ./components/advantages/Advantages.js